// extracted by mini-css-extract-plugin
export default {"permissions_table":"Permissions_permissions_table__qpjHc","checkbox_wrapper":"Permissions_checkbox_wrapper__LEIy+"};